// Google Apps Script Web App endpoint for Saudi Investment Bridge forms
const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyEUVMUPl_RsMe0egK5FYP3bQ9JxDefktKdaqInqgjxASYlAcpysSZ6xJOWFQhT6g3i8w/exec';

// Persistent visitor id per browser
export const getVisitorId = () => {
  if (typeof window === 'undefined') return '';
  let vid = localStorage.getItem('sib_visitor_id');
  if (!vid) {
    const rand = () => Math.floor(Math.random() * 16).toString(16).toUpperCase();
    vid = 'VID-' + Array.from({ length: 12 }, rand).join('');
    localStorage.setItem('sib_visitor_id', vid);
  }
  return vid;
};

// Generate 8-char uppercase hex id with a prefix, e.g. SIB-CONTACT-A84F21CD
export const generateSubmissionId = (prefix) => {
  const rand = () => Math.floor(Math.random() * 16).toString(16).toUpperCase();
  return `${prefix}-${Array.from({ length: 8 }, rand).join('')}`;
};

/**
 * Sanitize phone / whatsapp inputs. Only digits, +, spaces, dashes and
 * parentheses are allowed. Anything else typed or pasted is stripped.
 * Max length capped at 20 characters.
 */
export const sanitizePhone = (raw) => {
  if (raw == null) return '';
  return String(raw).replace(/[^0-9+\s\-()]/g, '').slice(0, 20);
};

/**
 * Submit form data to Google Apps Script Web App using a hidden iframe POST.
 * This method bypasses CORS entirely (the browser treats it like a native form
 * submit) so Google Apps Script receives the fields in `e.parameter`.
 */
export const submitToSheet = (payload) => {
  return new Promise((resolve) => {
    if (typeof document === 'undefined') { resolve({ success: false }); return; }

    const iframeName = `sib_submit_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    const iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = GOOGLE_SCRIPT_URL;
    form.target = iframeName;
    form.enctype = 'application/x-www-form-urlencoded';
    form.style.display = 'none';
    form.acceptCharset = 'UTF-8';

    Object.entries(payload).forEach(([k, v]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = k;
      input.value = typeof v === 'object' ? JSON.stringify(v) : String(v ?? '');
      form.appendChild(input);
    });

    document.body.appendChild(form);

    let done = false;
    const cleanup = () => {
      if (done) return;
      done = true;
      try { document.body.removeChild(form); } catch (e) {}
      try { document.body.removeChild(iframe); } catch (e) {}
      resolve({ success: true });
    };

    iframe.addEventListener('load', () => setTimeout(cleanup, 300));
    setTimeout(cleanup, 4000);

    try { form.submit(); } catch (e) { cleanup(); }
  });
};

/**
 * Fires a one-off "deployment ping" per browser session so you can verify in
 * the Sheet that the pipeline is still alive after a new deployment. Uses
 * sessionStorage to make sure it only fires once per tab session.
 */
export const sendDeploymentPing = () => {
  if (typeof window === 'undefined') return;
  try {
    if (sessionStorage.getItem('sib_ping_sent')) return;
    sessionStorage.setItem('sib_ping_sent', '1');
    submitToSheet({
      form_type: 'deployment_ping',
      submission_id: generateSubmissionId('SIB-PING'),
      visitor_id: getVisitorId(),
      language: (typeof document !== 'undefined' && document.documentElement.lang) || 'en',
      page_source: 'system',
      user_agent: (typeof navigator !== 'undefined' && navigator.userAgent) || '',
      referrer: (typeof document !== 'undefined' && document.referrer) || '',
      timestamp: new Date().toISOString(),
      status: 'ping'
    });
  } catch (e) { /* swallow */ }
};
